import React from "react";
import { FormattedMessage } from "react-intl";
import { Card, Row } from "@masterteam/mt-design-react";

import BarChart from "../BarChart";
import KPIStatusIndicator from "../../../KPIStatusIndicator";

import "./style.scss";

const ChartCard = ({ data, title, statuses, isProject = false }) => {
  return (
    <Card className="dashboard-summary-card">
      <Row
        className="dashboard-summary-card__title"
        align="center"
        justify="center"
      >
        <FormattedMessage id={title} />
      </Row>

      <Row className="dashboard-summary-card_chart" gap={36} justify="between">
        {data.OrgStructures?.map((e) => (
          <BarChart data={e} statuses={statuses} isProject={isProject} />
        ))}
      </Row>

      <Row
        className="dashboard-summary-card__statuses"
        justify="center"
        size="medium"
        wrap
      >
        {statuses.map((_item, index) => (
          <KPIStatusIndicator item={_item} key={index} />
        ))}
      </Row>
    </Card>
  );
};

export default ChartCard;
